import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=75d8d1db&scoped=true&"
import script from "./header-search.vue?vue&type=script&lang=js&"
export * from "./header-search.vue?vue&type=script&lang=js&"
import style0 from "./header-search.vue?vue&type=style&index=0&id=75d8d1db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d8d1db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d8d1db')) {
      api.createRecord('75d8d1db', component.options)
    } else {
      api.reload('75d8d1db', component.options)
    }
    module.hot.accept("./header-search.vue?vue&type=template&id=75d8d1db&scoped=true&", function () {
      api.rerender('75d8d1db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/header-search.vue"
export default component.exports